
/* eslint-disable no-magic-numbers -- numbers are required */

import { setConfiguration } from 'react-grid-system';

/**
 * Enum for screen size breakpoints in pixels.
 * These represent the min-width for each screen class.
 */
export enum Breakpoints {
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1200,
  XXL = 1600,
}

/**
 * Enum for the max-width of the container at each breakpoint.
 */
export enum ContainerWidths {
  SM = 540,
  MD = 720,
  LG = 960,
  XL = 1140,
  XXL = 1440, // The desired default max-width for large screens
}

export const initializeGridConfig = () => {
  const breakpointValues = Object.values(Breakpoints).filter(
    (value) => typeof value === 'number'
  );
  const containerWidthValues = Object.values(ContainerWidths).filter(
    (value) => typeof value === 'number'
  );

  setConfiguration({
    breakpoints: breakpointValues,
    containerWidths: containerWidthValues,
    gutterWidth: 30,
  });
};
